import { STREAM_BASE_URL } from "../config/env";

const STREAM_BASE = String(STREAM_BASE_URL || "").replace(/\/+$/, "");

/** Decode once, fix "video DE" → "video_DE" (keeps real filename spaces like "Video 1_..."). */
const normalizeVideoPath = (videoPath) => {
  let path = String(videoPath).trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    // keep raw path if malformed encoding
  }
  return path.replace(/\s+(DE|TR|BKS)(?=\/|_|\.|$)/gi, "_$1");
};

export const getStreamUrl = (videoPath) => {
  if (!videoPath) return "";
  if (/^https?:\/\//i.test(videoPath)) return videoPath;
  const name = normalizeVideoPath(videoPath);
  return `${STREAM_BASE}/stream?name=${encodeURIComponent(name)}`;
};

export const getPresignedUrlEndpoint = (videoPath) => {
  if (!videoPath) return "";
  const name = normalizeVideoPath(videoPath);
  return `${STREAM_BASE}/videos/presigned?name=${encodeURIComponent(name)}`;
};
